/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { trimValue } from './htmlDocumentUtils';
import { getSiteDisplayName } from '../../main/utils/siteDisplayName';

function DocumentBrandLogo({ src }) {
  const [resolvedSrc, setResolvedSrc] = useState(null);

  useEffect(() => {
    if (!src) {
      setResolvedSrc(null);
      return undefined;
    }

    let cancelled = false;
    const probe = new Image();

    probe.onload = () => {
      if (!cancelled) setResolvedSrc(src);
    };
    probe.onerror = () => {
      if (!cancelled) setResolvedSrc(null);
    };
    probe.src = src;

    return () => {
      cancelled = true;
    };
  }, [src]);

  if (!resolvedSrc) return null;

  return <img className="doc-brand-logo" src={resolvedSrc} alt="" />;
}

function MultilineText({ text, className }) {
  const trimmed = trimValue(text);
  if (!trimmed) return null;
  return trimmed.split(/\r?\n/).map((line, index) => (
    <p key={`ml-${index}`} className={className}>
      {line}
    </p>
  ));
}

export function DocumentCompanyHeader({ settings }) {
  const { t, i18n } = useTranslation('ui');
  const siteName = getSiteDisplayName(settings, i18n.language) || t('pdfDocuments.common.emDash');
  const siteIcon = trimValue(settings?.site_icon);
  const crNumber = trimValue(settings?.cr_number);
  const address = trimValue(settings?.address);
  const vatNumber = trimValue(settings?.vat_number);

  return (
    <div className="doc-brand-row">
      <DocumentBrandLogo src={siteIcon} />
      <div>
        <p className="doc-brand-name">{siteName}</p>
        {crNumber ? (
          <p className="doc-company-line">
            <strong>{t('pdfDocuments.common.crLabel')}</strong> {crNumber}
          </p>
        ) : null}
        {vatNumber ? (
          <p className="doc-company-line">
            <strong>{t('pdfDocuments.common.vatLabel')}</strong> {vatNumber}
          </p>
        ) : null}
        {address ? (
          <div>
            <p className="doc-company-line">
              <strong>{t('pdfDocuments.common.address')}</strong>
            </p>
            <MultilineText text={address} className="doc-company-line" />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export function DocumentCompanyFooter({ settings }) {
  const { t } = useTranslation('ui');
  const bankDetails = trimValue(settings?.bank_details);
  if (!bankDetails) return null;

  return (
    <div className="doc-footer-box">
      <p className="doc-footer-title">{t('pdfDocuments.common.bankDetails')}</p>
      <MultilineText text={bankDetails} className="doc-footer-line" />
    </div>
  );
}
